import { createSlice } from "@reduxjs/toolkit";
import { getResumeViewLogs } from "./thunk";

export interface IState {
  resumeViewLogs: any;
  isResumeViewLogLoading: boolean;
  isResumeViewLogSuccess: boolean;

  error: any;
}

export const initialState: IState = {
  resumeViewLogs: null,
  isResumeViewLogLoading: false,
  isResumeViewLogSuccess: false,

  error: {},
};

const ResumeViewLogSlice = createSlice({
  name: "ResumeViewLog",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getResumeViewLogs.pending, (state: IState, action: any) => {
      state.isResumeViewLogLoading = true;
    });
    builder.addCase(getResumeViewLogs.fulfilled, (state: IState, action: any) => {
      state.resumeViewLogs = action.payload.data;
      state.isResumeViewLogSuccess = true;
      state.isResumeViewLogLoading = false;
    });
    builder.addCase(getResumeViewLogs.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isResumeViewLogSuccess = false;
      state.isResumeViewLogLoading = false;
    });
  },
});

export default ResumeViewLogSlice.reducer;